import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Plus, Trash2 } from 'lucide-react';
import { api } from '../lib/api';
import { Dialog } from '../components/Dialog';

export default function Holidays() {
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState<any>({ recurring: false, enabled: true });
  const { data: list = [] } = useQuery({ queryKey: ['holidays'], queryFn: () => api.holidays.list() });

  const create = useMutation({
    mutationFn: () => api.holidays.create(form),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['holidays'] }); setOpen(false); },
  });
  const remove = useMutation({
    mutationFn: (id: string) => api.holidays.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['holidays'] }),
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Holidays</h1>
        <button onClick={() => setOpen(true)} className="btn-primary inline-flex items-center gap-2"><Plus size={14} /> Add Holiday</button>
      </div>
      <div className="card p-0 overflow-hidden">
        <table className="table">
          <thead><tr><th>Name</th><th>Starts</th><th>Ends</th><th>Recurring</th><th>Destination</th><th></th></tr></thead>
          <tbody>
            {(list as any[]).map((h: any) => (
              <tr key={h.holiday_uuid} className="hover:bg-elevated">
                <td>{h.name}</td>
                <td className="font-mono">{h.starts_on}{h.starts_time ? ` ${h.starts_time}` : ''}</td>
                <td className="font-mono">{h.ends_on}{h.ends_time ? ` ${h.ends_time}` : ''}</td>
                <td>{h.recurring ? <span className="badge-up">yes</span> : '—'}</td>
                <td className="font-mono">{h.destination || '—'}</td>
                <td><button onClick={() => remove.mutate(h.holiday_uuid)} className="btn-ghost p-1 text-danger"><Trash2 size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Dialog open={open} onClose={() => setOpen(false)} title="Add Holiday" size="md"
        footer={<><button onClick={() => setOpen(false)} className="btn-ghost">Cancel</button><button onClick={() => create.mutate()} className="btn-primary">Save</button></>}>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2">
            <label className="block text-sm text-textSecondary mb-1">Name *</label>
            <input className="input" value={form.name || ''} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          </div>
          <div>
            <label className="block text-sm text-textSecondary mb-1">Starts on *</label>
            <input className="input" type="date" value={form.starts_on || ''} onChange={(e) => setForm({ ...form, starts_on: e.target.value })} />
          </div>
          <div>
            <label className="block text-sm text-textSecondary mb-1">Ends on *</label>
            <input className="input" type="date" value={form.ends_on || ''} onChange={(e) => setForm({ ...form, ends_on: e.target.value })} />
          </div>
          <div>
            <label className="block text-sm text-textSecondary mb-1">Starts time (optional)</label>
            <input className="input" type="time" value={form.starts_time || ''} onChange={(e) => setForm({ ...form, starts_time: e.target.value })} />
          </div>
          <div>
            <label className="block text-sm text-textSecondary mb-1">Ends time (optional)</label>
            <input className="input" type="time" value={form.ends_time || ''} onChange={(e) => setForm({ ...form, ends_time: e.target.value })} />
          </div>
          <label className="col-span-2 flex items-center gap-2 text-sm">
            <input type="checkbox" checked={!!form.recurring} onChange={(e) => setForm({ ...form, recurring: e.target.checked })} />
            Recurring annually on the same day
          </label>
          <div className="col-span-2">
            <label className="block text-sm text-textSecondary mb-1">Holiday route destination</label>
            <input className="input font-mono" value={form.destination || ''} onChange={(e) => setForm({ ...form, destination: e.target.value })}
              placeholder="extension, ring group, voicemail (optional)" />
          </div>
        </div>
      </Dialog>
    </div>
  );
}
